import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface StatCardProps {
  icon: ReactNode;
  label: string;
  value: string | number;
  subValue?: string;
  href?: string;
  disabled?: boolean;
}

export function StatCard({ icon, label, value, subValue, href, disabled }: StatCardProps) {
  const content = (
    <div
      className={`
        flex items-center gap-3 rounded border border-border bg-background-subtle p-3
        ${disabled ? 'opacity-50' : 'hover:border-border-muted hover:bg-background-elevated'}
        transition-colors
      `}
    >
      <div className="flex h-9 w-9 items-center justify-center rounded bg-background-elevated text-primary">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs text-foreground-muted truncate">{label}</p>
        <div className="flex items-baseline gap-2">
          <p className="text-lg font-semibold text-foreground tabular-nums">{value}</p>
          {subValue && (
            <p className="text-xs text-foreground-subtle truncate">{subValue}</p>
          )}
        </div>
      </div>
    </div>
  );

  if (disabled || !href) {
    return content;
  }

  return <Link to={href}>{content}</Link>;
}
